module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "grecaptcha": ""
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1aabd578"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/includes/components/forms/elements/grecaptcha.vue
// module id = 258
// module chunks = 38